import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  Input,
  BreadcrumbItem,
  CardHeader,
  FormGroup,
  CardTitle,
} from "reactstrap";
import { useState, React, useEffect, useRef, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "moment-timezone";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const CertificateUpload = () => {
  const history = useHistory();
  const privileges = useContext(MainContext);

  const [certificateValues, setCertificateValues] = useState({
    passphrase: "",
  });

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["versions.certificates.upload"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData();
  }, []);

  const fetchData = () => {
    fetch("/api/v1/version/certificate/upload", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {})
      .catch((err) => {
        console.log(err.message);
      });
  };

  const [showLoading, setShowLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState([]);

  const [file, setFile] = useState();
  const [uploadBtnEnabled, setUploadBtnEnabled] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setCertificateValues({
      ...certificateValues,
      [name]: value,
    });
  };

  const resetForm = () => {
    setCertificateValues({
      ...certificateValues,
      ["passphrase"]: "",
    });
  };

  const handleUpload = () => {
    setShowLoading(true);

    const uploadFile = inputFileRef.current.files[0];

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("passphrase", certificateValues.passphrase);

    fetch("/api/v1/version/certificate/upload", {
      method: "PUT",
      headers: {
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        setFile();
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);

        if (actualData.status != 200) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while uploading the certificate", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          resetForm();
          toast.success("Certificate uploaded successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        console.log(error.message);
        toast.error("A problem occured while uploading the certificate", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
        setShowLoading(false);
        setFile([]);
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);
        console.log(error.message);
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = Array.from(event.target.files);

    if (selectedFile == undefined || selectedFile.length == 0) {
      setUploadBtnEnabled(false);
    } else {
      setUploadBtnEnabled(true);
    }

    setFile(selectedFile);
  };

  const inputFileRef = useRef(null);

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Certificate Upload</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Certificate Upload</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Row>
                  <Col>
                    This section allows you to upload a new certificate (PEM
                    file). The file should contain the certificate and private
                    key together. <br />
                    <br />
                    If you have two separated files for saving certificate and
                    private key. (
                    <i>
                      <small>
                        Use the Linux cat command to combine them into a single
                        PEM file. For example, cat my.cert my.key &gt; my.pem
                      </small>
                    </i>
                    ) <br />
                    <br />
                    Notice that the RSA certificate is recommended since most of
                    the new version of browsers has removed support for DSA in
                    certificate.
                  </Col>
                </Row>
                <Row style={{ marginTop: "25px" }}>
                  <Col>
                    <label>Passphrase</label>
                    <FormGroup>
                      <Input
                        type="text"
                        name="passphrase"
                        onChange={handleInputChange}
                        value={
                          certificateValues ? certificateValues.passphrase : ""
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row style={{ marginBottom: "25px" }}>
                  <Col>
                    <div>
                      <input
                        type="file"
                        onChange={handleFileChange}
                        ref={inputFileRef}
                        accept=".pem"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div>
                      <button
                        onClick={handleUpload}
                        disabled={!uploadBtnEnabled}
                      >
                        Upload
                      </button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CertificateUpload;
